import { render } from "./cont_comments.vue?vue&type=template&id=2ab26ba6&scoped=true"
import script from "./cont_comments.vue?vue&type=script&lang=js"
export * from "./cont_comments.vue?vue&type=script&lang=js"

import "./cont_comments.vue?vue&type=style&index=0&id=2ab26ba6&scoped=true&lang=css"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab26ba6"],['__file',"vue/js/components/sale/users/profile/info/tabs/cont_comments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ab26ba6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ab26ba6', __exports__)) {
    console.log('reload')
    api.reload('2ab26ba6', __exports__)
  }
  
  module.hot.accept("./cont_comments.vue?vue&type=template&id=2ab26ba6&scoped=true", () => {
    console.log('re-render')
    api.rerender('2ab26ba6', render)
  })

}


export default __exports__